import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  type?: string;
}

const BASE_URL = 'https://playerslockeroom.com';
const DEFAULT_IMAGE = 'https://gmmfphwrwhvixldazcmp.supabase.co/storage/v1/object/sign/images/PL%20Logo.svg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80Y2E1MDZiYi03YzlmLTQ3NWMtODU0My1iNzkyMTc5NjdjNjAiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvUEwgTG9nby5zdmciLCJpYXQiOjE3NTI3ODIwODUsImV4cCI6NDkwNjM4MjA4NX0.r9VxAKcMh1tB91moPz4hQCm-MqVHE_0ueHoOpq3UgDU';

export default function SEOHead({
  title,
  description = 'Players Lockeroom — Sports management, community, and NIL tools platform.',
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
}: SEOHeadProps) {
  const fullTitle = title ? `${title} | Players Lockeroom` : 'Players Lockeroom';
  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
